import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      color: "red-darken-1",
      class: "mb-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "concedii" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("Cereri Concediu", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "documente" }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Cereri Documente", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "concedii" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsConcedii,
              "show-borders": true,
              "row-alternation-enabled": true,
              "remote-operations": true
            }, {
              stareCellTemplate: _withCtx(({ data }) => [
                _createVNode(_component_v_chip, {
                  color: _ctx.stareColorConcediu(data.data.Stare),
                  size: "small",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.stareLabel(data.data.Stare)), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_DxColumn, {
                  "data-field": "DataCreare",
                  caption: "Data",
                  "data-type": "datetime",
                  format: "dd.MM.yyyy",
                  width: 120
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "AngajatID",
                  caption: "Angajat ID",
                  width: 300
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "DataInceput",
                  caption: "Start",
                  "data-type": "date",
                  format: "dd.MM.yyyy",
                  width: 110
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "DataSfarsit",
                  caption: "Sfârșit",
                  "data-type": "date",
                  format: "dd.MM.yyyy",
                  width: 110
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "NumarZile",
                  caption: "Zile",
                  width: 70
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "TipConcediu",
                  caption: "Tip",
                  width: 100
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Stare",
                  caption: "Stare",
                  width: 130,
                  "cell-template": "stareCellTemplate"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Descriere",
                  caption: "Observații"
                }),
                _createVNode(_component_DxFilterRow, { visible: true }),
                _createVNode(_component_DxPaging, { "page-size": 20 }),
                _createVNode(_component_DxSearchPanel, {
                  visible: true,
                  width: 200,
                  placeholder: "Caută..."
                }),
                _createVNode(_component_DxToolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxItem, {
                      location: "after",
                      name: "searchPanel"
                    }),
                    _createVNode(_component_DxItem, { location: "after" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxButton, {
                          icon: "refresh",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dsConcedii.reload()))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "documente" }, {
          default: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsDocumente,
              "show-borders": true,
              "row-alternation-enabled": true,
              "remote-operations": true
            }, {
              stareDocCellTemplate: _withCtx(({ data }) => [
                _createVNode(_component_v_chip, {
                  color: _ctx.stareColorDoc(data.data.Stare),
                  size: "small",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.data.Stare), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_DxColumn, {
                  "data-field": "DataCreare",
                  caption: "Data",
                  "data-type": "datetime",
                  format: "dd.MM.yyyy",
                  width: 120
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "AngajatID",
                  caption: "Angajat ID",
                  width: 300
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Stare",
                  caption: "Stare",
                  width: 130,
                  "cell-template": "stareDocCellTemplate"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Descriere",
                  caption: "Descriere"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "ObsevatieRaspuns",
                  caption: "Răspuns HR"
                }),
                _createVNode(_component_DxFilterRow, { visible: true }),
                _createVNode(_component_DxPaging, { "page-size": 20 }),
                _createVNode(_component_DxSearchPanel, {
                  visible: true,
                  width: 200,
                  placeholder: "Caută..."
                }),
                _createVNode(_component_DxToolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxItem, {
                      location: "after",
                      name: "searchPanel"
                    }),
                    _createVNode(_component_DxItem, { location: "after" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxButton, {
                          icon: "refresh",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dsDocumente.reload()))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data-source"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}